import { Card, Stack, Text, Textarea } from "@mantine/core";
import { useComposeFormContext } from "shared/components/message/compose/context";

type PreviewBlockProps = { label: string; value: string };

type PreviewSectionProps = PreviewBlockProps & {
    ariaText: string;
};

const PreviewSection = ({ label, value, ariaText }: PreviewSectionProps) => (
    <Card padding="sm" withBorder h="fit-content">
        <Stack gap="xs">
            <Text size="xs" c="dimmed">
                {label}
            </Text>
            <Textarea
                readOnly
                autosize
                variant="unstyled"
                value={value}
                styles={label === "Literal" ? { input: { fontFamily: "monospace" } } : undefined}
                aria-label={`${ariaText} preview${label === "Pretty" ? " (pretty)" : ""}`}
            />
        </Stack>
    </Card>
);

const PreviewBlock = ({ label, value }: PreviewBlockProps) => (
    <Stack gap="xs">
        <Text fw={500} size="sm">
            {label}
        </Text>
        <PreviewSection label="Literal" value={JSON.stringify(value ?? "").slice(1, -1)} ariaText={label} />
        <PreviewSection label="Pretty" value={value ?? ""} ariaText={label} />
    </Stack>
);

export const BodyPreview = () => {
    const form = useComposeFormContext();
    const { body, richBody } = form.getValues();

    return (
        <Stack>
            <PreviewBlock label="Body" value={body} />
            <PreviewBlock label="Rich Body" value={richBody} />
        </Stack>
    );
};
